import {
  RoadmapItemDto,
  RoadmapsClient,
} from "../../../../../customer-experience/src/lib/ShiOneClient";
import { useApi } from "../../../../../customer-experience/src/v2/src/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ROADMAPS_BY_ID } from "../utils/constants";
import { Dispatch, SetStateAction } from "react";
import { SnackbarState } from "../interfaces/SnackbarState";

export default function useCreateRoadmapItem(
  setSnackbars?: Dispatch<SetStateAction<SnackbarState[]>>,
  handleCloseDialog?: () => void,
) {
  const queryClient = useQueryClient();
  const api = useApi(RoadmapsClient);

  return useMutation({
    mutationFn: async (roadmapItemDto: RoadmapItemDto) => {
      return await api.createRoadmapItem(roadmapItemDto);
    },
    onSuccess: () => {
      if (handleCloseDialog) {
        handleCloseDialog();
      }
    },
    onError: async () => {
      setSnackbars?.((prev: SnackbarState[]) => [
        ...prev, {
          key: new Date().getTime() + Math.random(),
          message: "There was an issue creating the item, please try again later.",
          severity: "error",
        }
      ]);
    },
    onSettled: () => {
      queryClient
        .invalidateQueries({ queryKey: [CACHE_KEY_ROADMAPS_BY_ID] })
        .then();
    },
  });
}
